import axios from "../../privateApi";

export const editTactic = async ({
  tacticId,
  description,
  name,
  eaCode,
  isFavorite,
}: {
  tacticId: string;
  description?: string;
  name?: string;
  eaCode?: string;
  isFavorite?: boolean;
}) => {
  const payload: {
    description?: string;
    name?: string;
    eaCode?: string;
    isFavorite?: boolean;
  } = {};
  if (description) payload.description = description;
  if (name) payload.name = name;
  if (eaCode) payload.eaCode = eaCode;
  payload.isFavorite = isFavorite;
  try {
    const response = await axios.patch(`/tactics/${tacticId}?v=2`, payload);
    return response.data;
  } catch (error) {
    throw error.response?.status;
  }
};
